import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    fill: theme.palette.primary1,
    cursor: 'pointer',

    '& rect': {
      fill: theme.palette.primary1,
    },

    '& rect:first-child': {
      fill: theme.palette.lightGrey,
    },

    '&:hover': {
      '& rect': {
        fill: theme.palette.lightGrey,
      },
      '& rect:first-child': {
        fill: theme.palette.primary1,
      },
    },
  },
  active: {
    '& rect': {
      fill: theme.palette.lightGrey,
    },
    '& rect:first-child': {
      fill: theme.palette.primary1,
    },
  },
}));
